// A '.tsx' file enables JSX support in the TypeScript compiler, 
// for more information see the following page on the TypeScript wiki:
// https://github.com/Microsoft/TypeScript/wiki/JSX

import React from 'react';
import * as Inovx from '@shared';
import HierarchyItemServices from '../services/HierarchyItemServices';
var InovxControls = Inovx.Shared.Controls;

interface AssetBreadcrumbPanelProps extends React.PropsWithChildren<{}> {
    breadcrumbList: any[];
    //assetObjectListID: string;
    //projectID: string;
    showLastItem?: boolean;
    showLastItemChildren?: boolean;
    //isMarkedPoint: boolean;
    onBreadcrumbClick: (e: any, crumb: any) => void;
    onBreadcrumbChildClick: (e: any, parentAsset: INamedItem, childAsset: INamedItem) => void;
}

class AssetBreadcrumbPanel extends React.Component<AssetBreadcrumbPanelProps, any> {
    constructor(props: AssetBreadcrumbPanelProps) {
        super(props);
    }

    async onGetSeparatorListData(requestData: any, callback: (data: any) => void) {
        const data = await HierarchyItemServices.getChildNames(requestData.assetHierarchyID);
        callback(data);
    }

    render() {
        return (
            <span className='asset-breadcrumb-panel'>
                <InovxControls.NavigationBreadcrumbPanel
                    parameterMap={{ assetHierarchyID: "ID" }}
                    breadcrumbList={this.props.breadcrumbList}
                    onBreadcrumbClick={this.props.onBreadcrumbClick}
                    onBreadcrumbChildClick={this.props.onBreadcrumbChildClick}
                    displayProp="Name"
                    keyProps={["ID"]}
                    showLastItem={this.props.showLastItem}
                    showLastItemChildren={this.props.showLastItemChildren}
                    highlightActiveChildInList={false}
                    onGetSeparatorListData={this.onGetSeparatorListData}
                />
            </span>
        )
    }
}

export default AssetBreadcrumbPanel;